// extracted by mini-css-extract-plugin
module.exports = {"BreakdownDate":"BreakdownDate__BreakdownDate__BQtir","block":"BreakdownDate__block__xbZe2","positive":"BreakdownDate__positive__cZkyS","negative":"BreakdownDate__negative__dUjg7"};